import { ExerciseFactDTO } from '@/generated';
import { useExerciseFactsQuery } from '@/hooks/query-hooks';
import { Autocomplete, TextField } from '@mui/material';

export const ExerciseFactAutocomplete = (props: {
  selectedExerciseFactId?: string;
  setSelectedExerciseFact: (exerciseFact?: ExerciseFactDTO) => void;
  factExerciseId?: string;
}) => {
  const { exerciseFacts } = useExerciseFactsQuery();
  const { selectedExerciseFactId, setSelectedExerciseFact, factExerciseId } = props;

  return (
    <Autocomplete
      autoHighlight
      id="tags-outlined"
      defaultValue={exerciseFacts?.find((ef) => ef.id === selectedExerciseFactId)}
      onChange={(event, exerciseFact) => {
        if (exerciseFact) setSelectedExerciseFact(exerciseFact);
        else setSelectedExerciseFact(undefined);
      }}
      options={
        exerciseFacts?.filter((f) => {
          if (f.exerciseId !== undefined && f.exerciseId !== factExerciseId) return false;
          return true; //TODO: Reverse logic
        }) ?? []
      }
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      sx={{ minWidth: 200, paddingTop: 1 }}
      renderInput={(params) => <TextField variant="outlined" {...params} label={`Exercise Fact`} placeholder={selectedExerciseFactId ? `Select Exercise Fact` : undefined} />}
    />
  );
};
